import { useQuery } from "@tanstack/react-query";

import { type PermissionScopeEnum } from "@fitness-app/data-models";
import { type Database } from "@fitness-app/supabase";

import { useUserClaims } from "~/hooks/trainer/useUserClaims";
import { supabase } from "~/store/initializeStore";

export type ChatTeamMemberDirectoryEntry = Database["public"]["Views"]["chat_team_member_directory"]["Row"];

export const useChatTeamMemberDirectory = ({
  enabled,
  permissionScope,
}: {
  enabled: boolean;
  permissionScope: PermissionScopeEnum;
}) => {
  const { memberId } = useUserClaims();

  return useQuery({
    queryKey: ["chatTeamMemberDirectory", memberId, permissionScope],
    enabled: enabled && Boolean(memberId),
    queryFn: async (): Promise<ChatTeamMemberDirectoryEntry[]> => {
      const { data, error } = await supabase
        .from("chat_team_member_directory")
        .select("id, userId, firstName, lastName")
        .order("firstName")
        .order("lastName");

      if (error) {
        throw new Error(error.message);
      }

      return data;
    },
  });
};
